import type { CompanyConfig, DocumentRequirement } from './company-selection.component';

const createRequiredDocument = (
	type: string,
	label: string,
	required = true,
	allowed_file_types: string[] = ['pdf', 'jpg', 'jpeg', 'png'],
	max_file_size_mb = 10
): DocumentRequirement => ({
	type,
	label,
	required,
	allowed_file_types,
	max_file_size_mb,
	validation_rules: {}
});

export const MOCK_COMPANY_CONFIGS: CompanyConfig[] = [
	{
		id: 1,
		name: 'takealot',
		source_urlstring: 'assets/images/Takealot.svg',
		logo_url: 'assets/images/Takealot.svg',
		logo_alt: 'Takealot',
		required_documents: [],
		demand_creation: false,
		next_node: undefined,
		metadata: {}
	},
	{
		id: 2,
		name: 'vodapay',
		source_urlstring: 'assets/images/Vodapay.svg',
		logo_url: 'assets/images/Vodapay.svg',
		logo_alt: 'VodaPay',
		required_documents: [],
		demand_creation: false,
		next_node: undefined,
		metadata: {}
	},
	{
		id: 3,
		name: 'game',
		source_urlstring: 'assets/images/DarkGame.svg',
		logo_url: 'assets/images/DarkGame.svg',
		logo_alt: 'Game',
		required_documents: [
			createRequiredDocument('till_slip', 'Till Slip')
		],
		demand_creation: true,
		next_node: 'SupportingDocumentUpload',
		metadata: {}
	},
	{
		id: 4,
		name: 'builders',
		source_urlstring: 'assets/images/buildersSVG_1-01.svg',
		logo_url: 'assets/images/buildersSVG_1-01.svg',
		logo_alt: 'Builders',
		required_documents: [
			createRequiredDocument('voucher', 'Voucher'),
			createRequiredDocument('sales_order', 'Sales Order'),
			createRequiredDocument('till_slip', 'Till Slip', false)
		],
		demand_creation: true,
		next_node: 'SupportingDocumentUpload',
		metadata: {}
	},
	{
		id: 5,
		name: 'umoove',
		source_urlstring: 'assets/images/UMOOVE_logo2.svg',
		logo_url: 'assets/images/UMOOVE_logo2.svg',
		logo_alt: 'Umoove',
		required_documents: [],
		demand_creation: false,
		next_node: undefined,
		metadata: {}
	},
	{
		id: 6,
		name: 'discovery',
		source_urlstring: 'assets/images/Discovery_Bank.svg',
		logo_url: 'assets/images/Discovery_Bank.svg',
		logo_alt: 'Discovery',
		required_documents: [],
		demand_creation: false,
		next_node: undefined,
		metadata: {}
	},
	{
		id: 7,
		name: 'midea',
		source_urlstring: 'assets/images/Midea_Logo_Lozenge.svg',
		logo_url: 'assets/images/Midea_Logo_Lozenge.svg',
		logo_alt: 'Midea',
		required_documents: [],
		demand_creation: false,
		next_node: undefined,
		metadata: {}
	},
	{
		id: 8,
		name: 'incredible connection',
		source_urlstring: 'assets/images/IncredibleLOGO_IC_primary2CLR.svg',
		logo_url: 'assets/images/IncredibleLOGO_IC_primary2CLR.svg',
		logo_alt: 'Incredible Connection',
		required_documents: [],
		demand_creation: false,
		next_node: undefined,
		metadata: {}
	},
	{
		id: 9,
		name: 'hi-fi corporation',
		source_urlstring: 'assets/images/HiFi_LogoRED.svg',
		logo_url: 'assets/images/HiFi_LogoRED.svg',
		logo_alt: 'Hi-Fi Corporation',
		required_documents: [],
		demand_creation: false,
		next_node: undefined,
		metadata: {}
	},
	{
		id: 10,
		name: 'rototank',
		source_urlstring: 'assets/images/rototank.svg',
		logo_url: 'assets/images/rototank.svg',
		logo_alt: 'Rototank',
		required_documents: [],
		demand_creation: false,
		next_node: undefined,
		metadata: {}
	},
	{
		id: 11,
		name: 'makro',
		// Placeholder until the correct SVG path is provided
		source_urlstring: 'assets/images/makro.svg',
		logo_url: 'assets/images/makro.svg',
		logo_alt: 'Makro',
		required_documents: [
			createRequiredDocument('invoice', 'Invoice'),
			createRequiredDocument('till_slip', 'Till Slip')
		],
		demand_creation: true,
		next_node: 'SupportingDocumentUpload',
		metadata: {}
	}
];


